import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/PreAdvise/PreAdvise.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import searchimg from '../../../Assets/TruckVisits/Assets-Desktop/search-icon.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
class PreAdvise extends Component {
    constructor(props) {
        super(props)
        this.state = {
            preadvisedata: [
                { id: 1, containerNo: "12345", bookingNo: "23456", port: "KHH" },
                { id: 2, containerNo: "34567", bookingNo: "45678", port: "KHH" },
                { id: 3, containerNo: "56789", bookingNo: "67890", port: "KHH" }],
            search: "",
            searchlength: 0,
            preadvisedata1: []
        }
        this.handlechangeSearch = this.handlechangeSearch.bind(this);
    }
    handleContainer = event => {
        this.state.preadvisedata1?.find((preadvisedata11) => {
            if (preadvisedata11?.id === event + 1) {
                this.props.history.push('/home')
            }
        })
    }
    toPreadviseDetails = () => {
        this.props.history.push('/PreadviseDetails')
    }
    handlechangeSearch = (e) => {
        this.setState({
            search: e.target.value,
            searchlength: e?.target?.value?.length
        });
    };
    searchContainer = () => {
        if (this.state.searchlength > 0) {
            const preadvisedata2 = this.state.preadvisedata.filter(i => i.containerNo == this.state.search)
            this.setState({ preadvisedata1: preadvisedata2 });
            console.log("inside search function", this.state.preadvisedata1);
        }
    }
    render() {
        if (this.state.searchlength == 0) {
            this.state.preadvisedata1 = this.state.preadvisedata;
            console.log("inside render search", this.state.preadvisedata1);
        }
        return (
            <div class="csoutercolor">
                <MetaDecorator title={TitleDescription.preAdvisePageTitle} description={TitleDescription.preAdvisePageDescription} />
                <Header tilesFetched={() => { }} />
                <div class="csnofullpread">
                    <div id="csnobox1pree">
                        <nav class="ccnononavbarpre1">
                            <div className="ccnonavbarname">
                                <small id="nonavcpre"> Track History for Single Container</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="preadnotificationmaincard">
                            <div class="concsdivlow199">
                                <div class="csdivlow2pre1">
                                    <input
                                        className="preSearch"
                                        placeholder="Search by Container No."
                                        autoComplete="off"
                                        id="secrchInput1pre11"
                                        onChange={this.handlechangeSearch}
                                        value={this.state.search}
                                    ></input>
                                    <img onClick={this.searchContainer} id="searchpre_img12" src={searchimg} width="16" height="16" />
                                </div>
                            </div>
                            {(this.state.preadvisedata1?.map((preadvisedata11, index) => {
                                return (
                                    <div class="consdiv1pre" onClick={this.toPreadviseDetails}>
                                        <div class="consdiv2" >
                                            <div class="consdiv3pre11">
                                                <div class="cardleft111">
                                                    <div class="cardleft11pre">
                                                        <small id="container">Container No. :</small>
                                                        <small id="containervalue">{preadvisedata11?.containerNo}</small>
                                                    </div>
                                                </div>
                                                <div class="cardleft2pre11">
                                                    <div class="cardleft21pre">
                                                        <small id="booking">Booking No. :</small>
                                                        <small id="bookingvalue">{preadvisedata11?.bookingNo}</small>
                                                    </div>
                                                </div>
                                                <div class="cardleft3pre11">
                                                    <small id="port">Port of Discharge :</small>
                                                    <small id="portvalue">{preadvisedata11?.port}</small>
                                                </div>
                                            </div>
                                            <div class="consdiv12pre11" onClick={() => this.handleContainer(index)}>
                                                <img src={rightarrow} id="rightarrowimg" height="16" width="16" class="" alt="" loading="lazy" />
                                            </div>
                                        </div>
                                    </div>);
                            }))}
                        </div>
                    </div>
                </div>
                <div class="notifooter01">
                    <Footer />
                </div>
                <div class="notifooter02">
                    <Footer2 />
                </div>
            </div>
        );
    }
}
export default PreAdvise;